var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9091 12C22.9091 18.0321 18.0321 22.9091 12 22.9091C5.96792 22.9091 1.09091 18.0321 1.09091 12C1.09091 5.96791 5.96792 1.09091 12 1.09091C18.0321 1.09091 22.9091 5.96791 22.9091 12Z",
    fill: "#8276F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4798 7.68008C12.6653 7.86564 12.6653 8.16651 12.4798 8.35208L9.53887 11.293C9.14835 11.6835 9.14835 12.3167 9.53887 12.7072L12.4798 15.6481C12.6653 15.8336 12.6653 16.1345 12.4798 16.3201C12.2942 16.5056 11.9933 16.5056 11.8078 16.3201L8.19487 12.7072C7.80435 12.3167 7.80435 11.6835 8.19487 11.293L11.8078 7.68008C11.9933 7.49451 12.2942 7.49451 12.4798 7.68008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63997 12.4799C8.37488 12.4799 8.15997 12.265 8.15997 11.9999C8.15997 11.7348 8.37488 11.5199 8.63997 11.5199L15.84 11.5199C16.1051 11.5199 16.32 11.7348 16.32 11.9999C16.32 12.265 16.1051 12.4799 15.84 12.4799L8.63997 12.4799Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.903fe60e9a72082aa97fdd8222de669a.svg";
export { ForwardRef as ReactComponent };